
import { Button } from "@mui/material";
import { CheckCircle as CheckCircle2, ArrowRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Step5Success = () => {
  const navigate = useNavigate();
  const items = [
  "Conta de administrador ativa",
  "Licença de teste criada para o primeiro número",
  "Com o número convidado ativo, você já começa a monitorá-lo",
  "Aproveite o teste de 7 dias!"];


  return (
    <div className="w-full max-w-lg mx-auto text-center">
      
      <h1 className="font-bold text-foreground mb-2 text-3xl">Tudo pronto! Seu período de teste gratuito do Kwik Scout foi ativado

      </h1>
      <p className="text-sm text-muted-foreground mb-8">
        Agora você já pode acompanhar as primeiras conversas monitoradas.
      </p>

      <div className="bg-card rounded-lg border border-border shadow-sm p-6 mb-8 text-left">
        <h2 className="text-sm font-bold text-foreground mb-4">Configuração concluída</h2>
        <ul className="space-y-3">
          {items.map((item, i) =>
          <li key={i} className="flex items-start gap-3">
              <CheckCircle2 className="h-5 w-5 text-accent shrink-0 mt-0.5" />
              <span className="text-sm text-foreground">{item}</span>
            </li>
          )}
        </ul>
      </div>

      <Button size="large" variant='contained' className="gap-2" onClick={() => navigate('/home')}>
        Acessar painel agora
        <ArrowRight className="h-4 w-4" />
      </Button>
    </div>);

};

export default Step5Success;